<template>

    <div class="col-lg clr2 py-4">
		<h1 class="py-3 px-5 display-4 text-light">Bid/Ask</h1>
	</div>
    <form @submit.prevent="handleSubmit">
        <div class="form-row mx-sm-3 py-4">
            <p class="text-uppercase h0">{{targetStock}}</P>
            <h1>{{ price }}</h1>
            <div class="form-group col-2 ">
                <label>Number of stocks:</label>
                <input class="form-control" v-model="numberStocks" type="number" placeholder="0">
            </div>
            <!--
            <div class="form-group col-2">
                <label>Set a Price:</label>
                <input class="form-control" v-model="price" type="number" placeholder="0" required>
            </div>
            -->
        </div>
        <button class="btn btn-primary mx-sm-3 btn-warning"  @click="this.buy = true">Buy</button>
        <button class="btn btn-primary mx-sm-3 btn-warning"  @click="this.buy = false">Sell</button><!-- on submit you would lead back to the stock center and it would alert whether transaction was successful
        make a try catch exception here-->
        {{message}}

    </form>
    <div class="form-row mx-sm-3 py-4">
        <router-link :to="'/tradingcentre' + '/' + this.uid" class="btn btn-dark" aria-current="page" >Back</router-link>
    </div>
</template>

<script>
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  getDoc,
  exists,
  updateDoc
} from "firebase/firestore";
import { getDatabase, ref, child, get, onValue, set} from "firebase/database";
import { isProxy, toRaw } from 'vue';


export default {
    props: [''],
	data() {
		return {
            db: getFirestore(this.$app),
			numberStocks: 0,
            price: 0,
            uid: this.$route.params.uid,
            message: '',
            channels: {},
            targetStock: this.$route.params.stock,
            //bid: true,
            buy: true
            /*
            bidsPrice: null,
            bidsShares: null,
            bidsStock: null,
            bidsUid: null, 

            asksPrice: null,
            asksShares: null,
            asksStock: null,
            asksUid: null
            */
		}
	},
	methods: {
        handleSubmit() {
            let usernetworth =0;
            let userstocks =0;
            const docRef = doc(this.db, "users", this.uid);
            getDoc(docRef)
                .then((docSnap1) => {
                   usernetworth = docSnap1.data().networth;
                   userstocks = docSnap1.data().stocks;
                   let usershares = docSnap1.data().shares;
                   let userasks = docSnap1.data().asks;
                   let useraskShares= docSnap1.data().askShares;
                   let userbids = docSnap1.data().bids;
                   let userbidShares = docSnap1.data().bidShares;

                    if((usernetworth < this.price*this.numberStocks && this.buy) || ((usershares[userstocks.indexOf(this.targetStock)] < this.numberStocks) && !this.buy) || this.numberStocks<=0 || this.price<=0 || !Number.isInteger(this.numberStocks)) {
                        this.message="Invalid input!"
                    }  else {

                        const channeldb = getDatabase()
		                const stocksRef = ref(channeldb, 'Stocks');
		                onValue(stocksRef, (snapshot) => {
                            const targetStock = this.targetStock
  			                const data = snapshot.val();
  			                this.channels = data;
                            if (data[targetStock].shares < this.numberStocks) {
                                this.message="Invalid input!"
                            } else {

                                const price = this.price
                                const numberStocks = this.numberStocks

                                //const bidsRef = ref(channeldb, 'bids');
                                //const asksRef = ref(channeldb, 'asks')
                                if (this.buy) {
                                usernetworth -= this.price*this.numberStocks
                                console.log("networth " + usernetworth)
                                if (userstocks.includes(this.targetStock)) {
                                    usershares[userstocks.indexOf(this.targetStock)] += this.numberStocks
                                } else {
                                    usershares.push(this.numberStocks)
                                    userstocks.push(this.targetStock)
                                }
                                updateDoc(docRef, {
                                    networth: usernetworth,
                                    stocks: userstocks,
                                    shares: usershares
                                })
                                .then(() => {
                                    
                                    this.numberStocks=0
                                })
                                .catch((error) => {
                                    console.log(error.message)
                                })
                                } else {
                                usernetworth += this.price*this.numberStocks
                                console.log("networth " + usernetworth)
                                    if(usershares[userstocks.indexOf(this.targetStock)] > this.numberStocks) {
                                        usershares[userstocks.indexOf(this.targetStock)] -= this.numberStocks
                                    } else {
                                        userstocks.splice(userstocks.indexOf(this.targetStock),1)
                                        usershares.splice(userstocks.indexOf(this.targetStock),1)
                                    }
                                    updateDoc(docRef, {
                                    networth: usernetworth,
                                    stocks: userstocks,
                                    shares: usershares
                                    })
                                    .then(() => {
                                       
                                        this.numberStocks=0
                                    })
                                    .catch((error) => {
                                    console.log(error.message)
                                    })
                                }

                                /*
                                const removeAndRebuild = (object, field, index) => {
                                    delete object[field][index]
                                    object[field][0] -= 1
                                    const keys = Object.keys(object)
                                    let counter = 1;
                                    keys.forEach((key) => {
                                        object[counter] = object[key]
                                        delete object[key]
                                        counter++;
                                    })
                                }
                                */
                                /*
                                if(this.bid) {
                                   onValue(bidsRef, (snapshot) => { //adding bid
                                        const bidsData = snapshot.val()
                                        bidsData.price[bidsData.price[0]] = this.price
                                        bidsData.price[0] += 1

                                        bidsData.shares[bidsData.shares[0]] = this.numberStocks
                                        bidsData.shares[0] += 1

                                        bidsData.stock[bidsData.stock[0]] = this.targetStock
                                        bidsData.stock[0] += 1

                                        bidsData.uid[bidsData.uid[0]] = this.uid
                                        bidsData.uid[0] += 1



                                        //upload to database here
                                        console.log(bidsData)

                                        onValue(asksRef, (snapshot2) => {
                                            const asksData = snapshot2.val()
                                            for (let i = 1; i<bidsData.price[0]; i++) {
                                                console.log("i " + i + "  bidsdata " + bidsData.price[0])
                                                for (let j = 1; j <asksData.price[0]; j++) {
                                                    console.log("j " + j + "  asksdata " + asksData.price[0])
                                                    if (bidsData.price[i] > asksData.price[j] && bidsData.stock[i] === asksData.stock[j]) {
                                                        console.log(bidsData.shares)
                                                        console.log(asksData.shares)

                                                        getDoc(doc(this.db, "users", asksData.uid[j]))
                                                        .then((docSnap2) => {
                                                            console.log(docSnap2.data())
                                                            let otherusernetworth = docSnap2.data().networth;
                                                            let otheruserstocks = docSnap2.data().stocks;
                                                            let otherusershares = docSnap2.data().shares;

                                                           

                                                            if(bidsData.shares[i] > asksData.shares[j]) { //if find bid that has more shares than matching ask
                                                                otherusernetworth += bidsData.price[j]*asksData.shares[j]

  
                                                          
                                                                if (otherusershares[otheruserstocks.indexOf(asksData.stock[j])] <= asksData.shares[j]) { //if no more shares from asking user, remove stock and shares
                                                                        otheruserstocks.splice(otheruserstocks.indexOf(asksData.stock[j]),1)
                                                                        otherusershares.splice(otheruserstocks.indexOf(asksData.stock[j]),1)
                                                                } else {
                                                                    console.log(otherusershares[otheruserstocks.indexOf(asksData.stock[j])] + " - " + asksData.shares[j])
                                                                    otherusershares[otheruserstocks.indexOf(asksData.stock[j])] -= asksData.shares[j] //remove shares from asking user
                                                                   
                                                                }
                
                                                                bidsData.shares[i] -= asksData.shares[j]
                                                        
                                                                if (userstocks.includes(bidsData.stock[i])) {
                                                                    console.log( usershares[userstocks.indexOf(bidsData.stock[i])]+ " + " + asksData.shares[j])
                                                                    usershares[userstocks.indexOf(bidsData.stock[i])] += asksData.shares[j]
                                                                } else {
                                                                    usershares.push(asksData.shares[j])
                                                                    userstocks.push(bidsData.stock[i])
                                                                }
                                                                //essentially remove ask from database
                                                                console.log(otherusershares)
                                                                console.log(usershares)

                                                                updateDoc(docRef, {
                                                                    networth: usernetworth,
                                                                    stocks: userstocks,
                                                                    shares: usershares
                                                                 })
                                                                .then(() => {
                                                                    updateDoc(doc(this.db, "users", asksData.uid[j]), {
                                                                        networth: otherusernetworth,
                                                                        stocks: otheruserstocks,
                                                                        shares: otherusershares
                                                                    }).then(() =>{
                                                                        //remove ask from database
                                                                        asksData.shares[j] = 1000000000
                                                                        asksData.uid[j] = ""
                                                                        console.log(bidsData)
                                                                        console.log(asksData)
                                                                        this.numberStocks = 0;
                                                                        this.price = 0;

                                                                    })
                                                                    .catch((error) => {
                                                                        console.log(error.message)
                                                                    })
                                                                })
                                                                .catch((error) => {
                                                                    console.log(error.message);
                                                                });
                                                            } else {
                                                                otherusernetworth += bidsData.price[j]*bidsData.shares[i]
                                                                
                                                                otherusershares[otheruserstocks.indexOf(asksData.stock[j])] -= bidsData.shares[i] //remove shares from asking user
                                                
                                                                if (userstocks.includes(bidsData.stock[i])) {
                                                                    usershares[userstocks.indexOf(bidsData.stock[i])] += bidsData.shares[i]
                                                                } else {
                                                                    usershares.push(bidsData.shares[i])
                                                                    userstocks.push(bidsData.stock[i])
                                                                    console.log(usershares)
                                                                    console.log(userstocks)
                                                                }
                                                                console.log("networth " + usernetworth)
                                                                updateDoc(docRef, {
                                                                    networth: usernetworth,
                                                                    stocks: userstocks,
                                                                    shares: usershares
                                                                 })
                                                                .then(() => {
                                                                    updateDoc(doc(this.db, "users", asksData.uid[j]), {
                                                                        networth: otherusernetworth,
                                                                        stocks: otheruserstocks,
                                                                        shares: otherusershares
                                                                    }).then(() =>{
                                                                        //remove bid from database
                                                                        asksData.shares[j] -= bidsData.shares[i]
                                                                        bidsData.shares[i] = -1
                                                                        bidsData.uid[i] = ""
                                                                        console.log(bidsData)
                                                                        console.log(asksData)
                                                                        this.numberStocks = 0;
                                                                        this.price = 0;
                                                                        /*
                                                                        this.bidsPrice = bidsData.price
                                                                        this.bidsShares = bidsData.shares
                                                                        this.bidsStock = bidsData.stock
                                                                        this.bidsUid = bidsData.uid

                                                                        this.asksPrice = asksData.price
                                                                        this.asksShares = asksData.shares
                                                                        this.asksStock = asksData.stock
                                                                        this.asksUid = asksData.uid
                                                                        
                                                                    })
                                                                    .catch((error) => {
                                                                        console.log(error.message)
                                                                    })
                                                                })
                                                                .catch((error) => {
                                                                    console.log(error.message);
                                                                });


                                                            }

                                                
                                                        })

                                                    }
                                                }

                                            }
                                               

                                        });

                                    });
                                  
                                    
                                } else {
                                   
                                }
                                */
                               

                            }
                            

		                });



                        /*
                        const db = getDatabase();
                        const postData = {
                            author: username,
                            uid: uid,
                            body: body,
                            title: title,
                            starCount: 0,
                            authorPic: picture
                        };

                        // Get a key for a new Post.
                        const newPostKey = push(child(ref(db), 'posts')).key;

                        // Write the new post's data simultaneously in the posts list and the user's post list.
                        const updates = {};
                        updates['/posts/' + newPostKey] = postData;
                        updates['/user-posts/' + uid + '/' + newPostKey] = postData;

                        return update(ref(db), updates);
                        */

                        
                    }
             })
                .catch((error) => {
                console.log(error.message);
            });

    
            
        }
 
      
	}/*
        unmounted() {
            console.log("unmount")
            if (this.bidsPrice) {
                 console.log(this.bidsPrice)
                const channeldb = getDatabase()
                const bidsRef = ref(channeldb, 'bids')
                const asksRef = ref(channeldb, 'asks')

            set(bidsRef, {
                price: this.bidsPrice,
                shares: this.bidsShares,
                stock: this.bidsStock,
                uid: this.bidsUid
            });

            set(asksRef, {
                price: this.asksPrice,
                shares: this.asksShares,
                stock: this.asksStock,
                uid: this.asksUid
            });
            }
            
        }
        */
    ,mounted() {
        const db = getDatabase()
		const stocksRef = ref(db, 'Stocks');
		onValue(stocksRef, (snapshot) => {
  			const data = snapshot.val();
            this.price = Math.round((((data[this.targetStock].subs*0.676)+(data[this.targetStock].viewLikeRatio-0.1)*5000000)/10000) * 100) / 100
		});
    }
}
</script>
<style>
.container {
    align-items: flex-end !important;
}
.h0{
    font-size: 5rem;
}
.clr4{
    background-color: #91901C;
}
</style>
